export const GET_ITEMS = 'GET_ITEMS';
export const GET_ITEM = 'GET_ITEM';
export const NEW_ITEM = 'NEW_ITEM';
export const EDIT_ITEM = 'EDIT_ITEM';
export const DEL_ITEM = 'DEL_ITEM';

export default {
  GET_ITEMS,
  GET_ITEM,
  NEW_ITEM,
  EDIT_ITEM,
  DEL_ITEM,
}